import { apiClient } from './client';

// ---------------------------------------------------------------------------
// labor.api.ts — mano de obra por lote (jornadas). Espejo de labor.handler.ts.
// ---------------------------------------------------------------------------

export type LaborType = 'JORNAL' | 'DESTAJO' | 'CONTRATO';

export interface LaborRecord {
  laborId:            string;
  loteId:             string;
  tenantId:           string;
  date:               string;  // YYYY-MM-DD
  laborType:          LaborType;
  activity:           string;
  workers:            number;
  hoursPerWorker:     number;
  dailyRatePerWorker: number;
  totalCost:          number;
  notes?:             string;
  crewId?:            string;
  createdBy:          string;
  createdAt:          string;
}

export interface CreateLaborInput {
  date:               string;
  laborType:          LaborType;
  activity:           string;
  workers:            number;
  hoursPerWorker:     number;
  dailyRatePerWorker: number;
  notes?:             string;
}

export const fetchLaborByLote = async (loteId: string): Promise<LaborRecord[]> =>
  (await apiClient.get(`/api/lotes/${loteId}/labor`)).data;

export const createLabor = async (loteId: string, input: CreateLaborInput): Promise<LaborRecord> =>
  (await apiClient.post(`/api/lotes/${loteId}/labor`, input)).data;
